export default "__VITE_PUBLIC_ASSET__dc32a0a7__"